import { ClearSearchFacets } from "@/components/search/clear-search-facets"
import { SidebarFacet } from "@/components/search/sidebar-facet"

import { useEducatorFacetDescriptors } from "./facet-descriptors"

export function EducatorSearchFacets() {
  const descriptors = useEducatorFacetDescriptors()

  return (
    <>
      <ClearSearchFacets />
      {descriptors.map((descriptor) => (
        <SidebarFacet key={descriptor.id} descriptor={descriptor} />
      ))}
    </>
  )
}
